export enum RequestStatus {
    Idle,
    Success,
    Loading,
    LoadingBackground,
    Failed
}